(function () {
  'use strict';

  function initMarquee(wrapper) {
    if (wrapper.classList.contains('has-mobile-marquee')) return;

    var groups = Array.from(wrapper.children).filter(function (el) {
      return el.classList.contains('group-block');
    });
    if (groups.length < 2) return;

    var viewport = document.createElement('div');
    viewport.className = 'mobile-marquee-viewport';

    var track = document.createElement('div');
    track.className = 'mobile-marquee-track';

    // Move originals into track
    groups.forEach(function (g) {
      track.appendChild(g);
    });

    // Clone each for seamless loop — track is 2× wide, animation moves -50%
    groups.forEach(function (g) {
      var clone = g.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    viewport.appendChild(track);
    wrapper.appendChild(viewport);
    wrapper.classList.add('has-mobile-marquee');
  }

  function findImageMarqueeWrapper() {
    // Find any mobile-column section whose every group-block
    // contains only an image-block (the logo multicolumn section pattern)
    var candidates = document.querySelectorAll('.section-content-wrapper.mobile-column');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var groups = Array.from(el.children).filter(function (c) {
        return c.classList.contains('group-block');
      });
      if (groups.length >= 3 && groups.every(function (g) {
        return g.querySelector('.image-block') && !g.querySelector('.text-block');
      })) {
        return el;
      }
    }
    return null;
  }

  function setup() {
    if (window.innerWidth > 749) return;
    var wrapper = findImageMarqueeWrapper();
    if (wrapper) initMarquee(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
